import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RefundRequest} from "../../models/refund-request.model";

@Component({
  selector: 'app-refund-details',
  templateUrl: './refund-details.component.html',
  styleUrls: ['./refund-details.component.scss'],
})
export class RefundDetailsComponent implements OnInit {

  @Input() refund: RefundRequest;
  @Output() actionCanceledEmitter = new EventEmitter<RefundRequest>();

  constructor() {
  }


  onCancel() {
    this.actionCanceledEmitter.emit(this.refund);
  }

  ngOnInit(): void {
  }


}
